import React, { SVGProps } from "react";

export default function AnchorIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={17} height={16} viewBox="0 0 17 16" {...props}>
      <g fill="#797979">
        <path d="M15.443 0H9.428a.747.747 0 00-.752.743c0 .41.337.743.752.743h4.2l-7.74 7.646a.736.736 0 000 1.05.754.754 0 001.064 0l7.74-7.646v4.15c0 .41.336.743.751.743a.747.747 0 00.752-.743V.743A.747.747 0 0015.443 0z" />
        <path d="M12.236 7.467a.716.716 0 00-.72.71v6.4H1.44V4.623h6.478c.397 0 .72-.318.72-.71a.715.715 0 00-.72-.712H.72a.716.716 0 00-.72.711V15.29c0 .393.322.711.72.711h11.516c.398 0 .72-.318.72-.711V8.178a.716.716 0 00-.72-.711z" />
      </g>
    </svg>
  );
}
